import { Machine, Interpreter, MachineConfig, State, DoneInvokeEvent } from 'xstate';
import Async from '../../Async';
import Data from '../../Data';

import { BranchRecord } from '../../Data/organisations/@records/Branch';
import { UserRecord } from '../../Data/users/@records/User';
import { DetailOrganisationResponse } from '../../Async/Organisations/response_models';

// States

export enum States {
  ADD_USER_TO_BRANCH_SCREEN = 'ADD_USER_TO_BRANCH_SCREEN',
  ADD_USER_TO_BRANCH_REQUEST = 'ADD_USER_TO_BRANCH_REQUEST',
  ADD_USER_TO_BRANCH_SUCCESS = 'ADD_USER_TO_BRANCH_SUCCESS',
  ADD_USER_TO_BRANCH_ERROR = 'ADD_USER_TO_BRANCH_ERROR',
}

export type AutomataStates = {
  states: {
    [States.ADD_USER_TO_BRANCH_SCREEN]: {};
    [States.ADD_USER_TO_BRANCH_REQUEST]: {};
    [States.ADD_USER_TO_BRANCH_SUCCESS]: {};
    [States.ADD_USER_TO_BRANCH_ERROR]: {};
  };
};

// Context

export type AutomataContext = {
  branch: BranchRecord;
  user: UserRecord;
};

// Events

export enum Events {
  SUBMIT_DATA = 'SUBMIT_DATA',
}

export type SubmitData = {
  type: Events.SUBMIT_DATA;
};

export type AutomataEvent = SubmitData;

export type AutomataService = Interpreter<AutomataContext, AutomataStates, AutomataEvent>;
export type CurrentState = State<AutomataContext, AutomataEvent>;
export type Send = AutomataService['send'];

// Services

export const add_user_to_branch = (c: AutomataContext, e: AutomataEvent) =>
  // @ts-ignore
  Async.organisations.add_user_to_branch({
    userId: c.user.identifier,
    branchId: c.branch.identifier,
  });

// Actions

export const AddOrganisationToStore = (c: AutomataContext, e: DoneInvokeEvent<DetailOrganisationResponse>) =>
  Data.store.dispatch(Data.creators.organisation.saveOrganisationToStore(e.data.record));

// Config

export const config = (branch: BranchRecord, user: UserRecord): MachineConfig<AutomataContext, AutomataStates, AutomataEvent> => ({
  initial: States.ADD_USER_TO_BRANCH_SCREEN,
  context: {
    branch: branch,
    user: user,
  },
  states: {
    [States.ADD_USER_TO_BRANCH_SCREEN]: {
      on: {
        [Events.SUBMIT_DATA]: {
          target: States.ADD_USER_TO_BRANCH_REQUEST,
        },
      },
    },
    [States.ADD_USER_TO_BRANCH_REQUEST]: {
      invoke: {
        src: 'add_user_to_branch',
        onDone: {
          target: States.ADD_USER_TO_BRANCH_SUCCESS,
          actions: ['AddOrganisationToStore'],
        },
        onError: {
          target: States.ADD_USER_TO_BRANCH_ERROR,
          actions: [],
        },
      },
    },
    [States.ADD_USER_TO_BRANCH_SUCCESS]: {
      on: {
        [Events.SUBMIT_DATA]: {
          target: States.ADD_USER_TO_BRANCH_REQUEST,
        },
      },
    },
    [States.ADD_USER_TO_BRANCH_ERROR]: {
      on: {
        [Events.SUBMIT_DATA]: {
          target: States.ADD_USER_TO_BRANCH_REQUEST,
        },
      },
    },
  },
});

export const options: any = {
  services: {
    add_user_to_branch,
  },
  actions: {
    AddOrganisationToStore,
  },
};

export default (branch: BranchRecord, user: UserRecord) => Machine(config(branch, user), options);
